/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, Input } from '@angular/core';

import { ElMenuItem } from '../../components/menu/menu.service';
import { ElPositionedContainer, ElRenderableContainer } from '../cdk/overlay/overlay-container';

/**
 * Context menu component used as content within ElContextMenuDirective.
 *
 * @styles
 *
 * context-menu-background-color:
 * context-menu-border-color:
 * context-menu-border-style:
 * context-menu-border-width:
 * context-menu-border-radius:
 * context-menu-min-width:
 * context-menu-max-width:
 * context-menu-shadow:
 * */
@Component({
  selector: 'el-context-menu',
  template: `
    <el-menu class="context-menu" [items]="context.items" [tag]="context.tag"></el-menu>
  `,
})
export class ElContextMenuComponent extends ElPositionedContainer implements ElRenderableContainer {

  @Input() items: ElMenuItem[] = [];
  @Input() tag: string;

  @Input()
  context: { items: ElMenuItem[], tag?: string } = { items: [] };


  /**
   * The method is empty since we don't need to do anything additionally
   * render is handled by change detection
   */
  renderContent() {}
}
